import { useCallback, useEffect, useState } from "react";
import useApi from "../../../hooks/useApi";

const EMPTY = {
  periodo: null,
  kpis: null,
  vinculoPc: null,
  entrega: [],
};

/**
 * Carrega agregados do endpoint Dashboard (queries pontuais no backend).
 */
const useDashboardData = () => {
  const api = useApi();
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(EMPTY);

  const fetchAll = useCallback(
    async (isRefresh = false) => {
      if (isRefresh) setRefreshing(true);
      else setLoading(true);
      setError(null);

      try {
        const { data: payload } = await api.get(
          "Painel/API/Controladoria/Dashboard/index.php?dias=30"
        );

        setData({
          periodo: payload.periodo || null,
          kpis: payload.kpis || null,
          vinculoPc: payload.vinculo_pc || null,
          entrega: Array.isArray(payload.entrega) ? payload.entrega : [],
        });
      } catch (e) {
        setError(
          e?.response?.data?.message || "Erro ao carregar o dashboard."
        );
        setData(EMPTY);
      } finally {
        setLoading(false);
        setRefreshing(false);
      }
    },
    [api]
  );

  useEffect(() => {
    fetchAll(false);
  }, [fetchAll]);

  const refresh = useCallback(() => fetchAll(true), [fetchAll]);

  return { loading, refreshing, data, error, refresh };
};

export default useDashboardData;
